import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

import { AttributeOption } from '~shared/models';
import { NUMBER_0, NUMBER_5 } from '~shared/constants';

@Component({
  selector: 'app-brand-logos',
  templateUrl: './brand-logos.component.html',
  styleUrls: ['./brand-logos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandLogosComponent {
  @Input() brands: Array<AttributeOption>;
  @Input() isMobile: boolean;
  @Input() getBrandPath: (brandSlug: string) => string;
  @Output() onBrandClickGAEvent: EventEmitter<string> = new EventEmitter<string>();

  readonly NOT_EXPANDED_LIMIT: number = NUMBER_5;
  readonly NUMBER_0: number = NUMBER_0;
  isExpanded: boolean = false;

  get accordionLimit(): number {
    return this.isExpanded || !this.isMobile ? this.brands.length : this.NOT_EXPANDED_LIMIT;
  }

  constructor(private cd: ChangeDetectorRef) {}

  onBrandClick(brandSlug: string): void {
    this.onBrandClickGAEvent.emit(brandSlug);
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
    this.cd.markForCheck();
  }
}
